import styled from 'styled-components';

export const CommonCardContainer = styled.div`
  width: 100%;
  border-radius: 4px;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.08);
  background-color: ${props => props.theme.colors.black};
  margin-bottom: 10px;
  min-height: calc(100% - 10px);
  position: relative;
`;

export const Content = styled.div`
  padding: ${props => (props.noPadding ? '0px' : '15px 20px')};
`;

export const Title = styled.div`
  color: ${props => props.theme.colors.white};
`;

export const Description = styled.div`
  text-align: right;
  color: ${props => props.theme.colors.greyMedium};
  margin-left: auto;
`;

export const RightContent = styled.div`
  width: 50%;
  margin-left: auto;
`;

export const Header = styled.div`
  display: flex;
  border-bottom: solid 1px ${props => props.theme.colors.greyMedium};
  flex-direction: row;
  align-items: center;
  padding: 15px 20px;

  @media ${props => props.theme.device.mobileL} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    ${Description} {
      margin-left: 0;
    }

    &.lessons {
      flex-direction: column;
      align-items: flex-start;
      ${Title} {
        width: 80%;
        margin-bottom: 8px;
      }
    }
  }
`;

export const SpinnerContainer = styled.div`
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: center;
  width: 100%;

  // for IE
  min-height: 100%;
  min-width: 100%;
`;
